import { Box, Link, Typography } from '@mui/material';

export default function PoweredByZalb() {
  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        px: { xs: 2, md: 4 },
        pb: { xs: 3, md: 4 },
        pt: 1,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          fontSize: { xs: '0.75rem', md: '0.8rem' },
          lineHeight: 1.6,
          letterSpacing: '0.03em',
          color: 'rgba(27, 36, 32, 0.72)',
          textAlign: 'center',
        }}
      >
        Powered by{' '}
        <Link
          href="https://zalb.be"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          aria-label="Powered by Zalb — ouvrir le site Zalb dans un nouvel onglet"
          sx={{
            color: 'inherit',
            fontWeight: 600,
            borderRadius: '4px',
            textUnderlineOffset: '0.18em',
            transition: 'color 180ms ease, outline-color 180ms ease',
            '&:hover': {
              color: '#3f8f5b',
            },
            '&:focus-visible': {
              outline: '2px solid rgba(192, 110, 82, 0.55)',
              outlineOffset: '2px',
            },
          }}
        >
          Zalb
        </Link>
      </Typography>
    </Box>
  );
}
